import React from "react";

export default function Quotes() {

    const svg = `
<svg width="92px" height="118px" viewBox="0 0 92 118" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Icon-citation" transform="translate(1.000000, 1.000000)" stroke="#417505">
            <path d="M37.1627329,71.0220077 C37.1627329,71.0220077 72,71.0220077 72,35.5110039 C72,0 37.1627329,0 37.1627329,0 C37.1627329,0 0,0 0,35.5110039 C0,71.0220077 32.5162733,116 39.4842857,116 C46.4522981,116 2.32322981,71.0197683 37.1632919,71.0197683 L37.1627329,71.0220077 Z" id="Fill-1"></path>
            <path d="M72.5813665,78.5110039 C72.5813665,78.5110039 90,78.5110039 90,60.7555019 C90,43 72.5813665,43 72.5813665,43 C72.5813665,43 54,43 54,60.7555019 C54,78.5110039 70.2581366,101 73.7421429,101 C77.2261491,101 55.1616149,78.5098842 72.581646,78.5098842 L72.5813665,78.5110039 Z" id="Fill-3"></path>
        </g>
    </g>
</svg>`;

    return (
        <i className="icon" dangerouslySetInnerHTML={{__html: svg}}/>
    )
}
